var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogosMaster(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 15,
    viewBox: "0 0 23 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09302 1.8221H14.0913V12.6H8.09302V1.8221Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47382 7.21113C8.47382 5.02131 9.50207 3.07896 11.0825 1.82214C9.92104 0.908132 8.45483 0.355927 6.85529 0.355927C3.06575 0.355927 0 3.42168 0 7.21113C0 11.0005 3.06575 14.0663 6.8552 14.0663C8.45474 14.0663 9.92096 13.5141 11.0825 12.6C9.50207 11.3623 8.47382 9.40095 8.47382 7.21113Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1841 7.21108C22.1841 11.0004 19.1183 14.0663 15.3289 14.0663C13.7294 14.0663 12.2631 13.5141 11.1016 12.6C12.7011 11.3432 13.7104 9.4009 13.7104 7.21108C13.7104 5.02125 12.682 3.07891 11.1016 1.82209C12.263 0.908078 13.7294 0.355873 15.3289 0.355873C19.1183 0.355873 22.1842 3.44071 22.1842 7.21108H22.1841Z",
    fill: "#F79E1B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosMaster);
export default __webpack_public_path__ + "static/media/logos_master.448a5abf2cd5ad11bab80a6fd8fead7e.svg";
export { ForwardRef as ReactComponent };